<template>
    <div>
        <delete-icon-button
            v-if="!isConfirmOpen"
            :on-click-delete="handleOpenConfirm"
            :tooltip="tooltip"
            :data-cy="dataCy"
            :is-loading="isLoading"
            :is-disabled="isDisabled"
        />
        <div v-else class="flex flex-row gap-1">
            <Button
                :class="alignConfirm === 'right' ? 'order-1' : 'order-2'"
                size="sm"
                color="neutral"
                variant="soft"
                :data-cy="`${dataCy}-confirm-cancel`"
                @click.stop="handleCloseConfirm"
            >
                Avbryt
            </Button>
            <Button
                :class="alignConfirm === 'right' ? 'order-2' : 'order-1'"
                size="sm"
                color="error"
                icon="i-ph-trash-fill"
                :data-cy="`${dataCy}-confirm-delete`"
                @click.stop="handleClickDelete"
            >
                Slett
            </Button>
        </div>
    </div>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import Button from '@nuxt/ui/components/Button.vue'
import DeleteIconButton, {DeleteIconButtonProps} from '@/components/buttons/DeleteIconButton.vue'

type ConfirmableDeleteIconButton = DeleteIconButtonProps & {
    alignConfirm?: 'right' | 'left'
}

const props = withDefaults(defineProps<ConfirmableDeleteIconButton>(), {
    alignConfirm: 'right'
})

const isConfirmOpen = ref(false)

const handleOpenConfirm = () => {
    isConfirmOpen.value = true
}

const handleCloseConfirm = () => {
    isConfirmOpen.value = false
}

const handleClickDelete = () => {
    props.onClickDelete()
    handleCloseConfirm()
}
</script>

<style scoped>

</style>